import React, { useState } from 'react';
import './contactform.css';
import { FaArrowRight } from 'react-icons/fa';
import { message } from 'antd';
const ContactForm = () => {
  const [form, setForm] = useState({
    f_name: '',
    l_name: '',
    email: '',
    phone_number: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors = {};

    if (!form.f_name.trim()) newErrors.f_name = 'First name is required';
    if (!form.l_name.trim()) newErrors.l_name = 'Last name is required';

    if (!form.email) {
      newErrors.email = 'Email is required';
    } else if (!/^\S+@\S+\.\S+$/.test(form.email)) {
      newErrors.email = 'Email format is invalid';
    }

    if (!form.phone_number) {
      newErrors.phone_number = 'Phone number is required';
    } else if (!/^[0-9]{10,14}$/.test(form.phone_number)) {
      newErrors.phone_number = 'Enter a valid phone number';
    }

    // if (!form.message || form.message.length < 10) {
    //   newErrors.message = 'Message must be at least 10 characters';
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      setLoading(true);

      const response = await fetch('https://cafemandhurah.mandurahcafe.com.au/api/inquiries', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(form),
      });

      if (response.ok) {
       message.success('Message submitted successfully!');

        setForm({
          f_name: '',
          l_name: '',
          email: '',
          phone_number: '',
          message: '',
        });
        setErrors({});
      } else {
        message.error('Failed to submit. Please try again.');

      }
    } catch (error) {
      console.error('Submission error:', error);
      message.error('Something went wrong. Please try later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact-form-wrapper">
      <form className="contact-form" onSubmit={handleSubmit}>
        <h2>Write Your Queries Here !</h2>

        <div className="form-row">
          <input
            type="text"
            name="f_name"
            placeholder="Your First Name"
            value={form.f_name}
            onChange={handleChange}
            required
          />
          {errors.f_name && <span className="error-text">{errors.f_name}</span>}

          <input
            type="text"
            name="l_name"
            placeholder="Your Last Name"
            value={form.l_name}
            onChange={handleChange}
            required
          />
          {errors.l_name && <span className="error-text">{errors.l_name}</span>}
        </div>

        <div className="form-row">
          <input
            type="tel"
            name="phone_number"
            placeholder="Phone Number"
            value={form.phone_number}
            onChange={handleChange}
            required
          />
          {errors.phone_number && <span className="error-text">{errors.phone_number}</span>}

          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={form.email}
            onChange={handleChange}
            required
          />
          {errors.email && <span className="error-text">{errors.email}</span>}
        </div>

        <textarea
          name="message"
          rows="5"
          placeholder="Your Message"
          value={form.message}
          onChange={handleChange}
          
        ></textarea>
        {/* {errors.message && <span className="error-text">{errors.message}</span>} */}

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? 'Submitting...' : 'Submit Now'} <FaArrowRight style={{ marginLeft: '10px' }} />
        </button>
      </form>
    </section>
  );
};

export default ContactForm;
